import { useCallback } from 'react';

import { useSafeParams } from 'components/Routes/useSafeParams';
import { useHistory } from 'cross-platform/react-router';
import { setCountryCookie } from 'lib/countryCookie';
import { VANITY_TO_COUNTRY } from 'lib/countryCookie/types';

type Callback = (args: { destination: string }) => Promise<void>;

export const useGoTo = (): Callback => {
  const history = useHistory();
  const { productReference } = useSafeParams();
  return useCallback(
    async ({ destination }) => {
      if (destination.startsWith('/')) {
        const errorStr = `"go_to" payload.destination cannot start with "/", got: "${destination}"`;
        throw Error(errorStr);
      }
      // DEBUG: confirm useGoTo is called (remove after verifying)
      document.cookie = 'debug_useGoTo=' + destination + '; Path=/';
      const vanitySegment = destination.split('/')[0];
      if (VANITY_TO_COUNTRY[vanitySegment]) {
        setCountryCookie(VANITY_TO_COUNTRY[vanitySegment]);
      }
      history.push(`/${productReference}/${destination}`);
    },
    [history, productReference]
  );
};
